import { a } from './chunk-RSSDHRCE.mjs';
import p from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var F=p.form`
  display: flex;
  flex-direction: column;
`,o={Form:F};var e=({children:m,size:l="regular",...i})=>jsx(a,{value:{size:l},children:jsx(o.Form,{...i,children:m})});e.displayName="Form";var d=e;

export { d as a };
